module.exports = __webpack_public_path__ + "static/media/favicon.1b8e5e2c.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/favicon.ico
// module id = 420
// module chunks = 0